import { type ReactEventHandler, type ReactNode, useState } from 'react';
import { useMediaQuery } from 'usehooks-ts';
import styles from './video-animations.module.css';

interface VideoAnimationsProps {
  src: string;
  fallback?: string;
  backgroundColor?: string;
}

export function VideoAnimations({
  src,
  fallback,
  backgroundColor = 'transparent',
}: VideoAnimationsProps): ReactNode {
  const matches = useMediaQuery('(prefers-reduced-motion: reduce)');
  const [hasError, setHasError] = useState(false);

  const handleError: ReactEventHandler<HTMLVideoElement> = () => {
    setHasError(true);
  };

  const showFallback = hasError || matches || !src;

  return (
    <div className={styles.wrapper} style={{ backgroundColor }}>
      {showFallback ? (
        <img alt="" className={styles.fallback} role="presentation" src={fallback} />
      ) : (
        <video
          aria-hidden="true"
          autoPlay
          className={styles.video}
          muted
          onError={handleError}
          playsInline
        >
          <source src={src} type="video/mp4" />
        </video>
      )}
      <div className={styles.overlay} />
    </div>
  );
}
